import CallCenterReport from "./CallCenterReport";

const CallCenterReportConfig = {
	settings: {},
	routes: [
		{
			path: '/apps/callcenter/reports',
			component: CallCenterReport
		}
	]
};

export default CallCenterReportConfig;
